import { Injectable, ɵConsole } from '@angular/core';
import { errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";
import * as _ from "lodash";


@Injectable()
export class WavestatusdashboardService extends BaseService {

  constructor( private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) {    
    super();
  }

  colorCodes = [];

  init(widget: any) {
    this.colorCodes = this._commonService.getColorCodes();
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastWaveOrderStatus").subscribe(
      (data: any) => {
        //console.log("broadcastWaveOrderStatus", data);
        let result: Array<any> = [];
        result = data;
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        let criteria = widget.widgetsettings && widget.widgetsettings.Criteria ?
        JSON.parse(widget.widgetsettings.Criteria) : {WaveStatusType:''};
        switch(criteria.WaveStatusType){
            case "INDIVIDUAL WAVE" :
              widget.Title = "Individual Wave Status";
              break;
            case "INDIVIDUAL PACK WAVE" :
              widget.Title = "Individual Pack Wave Status";
              break;     
            default :
              widget.Title = "All Waves Status";      
              break;
        }

        if (result && result.length > 0) {
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId 
            && resultcreationtime == widget.widgetcreationtime 
            && !widget.IfNoDataFound) {
          widget.dataLoaded = false;         
          widget.errorMessage = null;

          switch(criteria.WaveStatusType){
            case "INDIVIDUAL WAVE" :
              this.loadWaveStatusIndividual(widget,result);
              break;
            case "INDIVIDUAL PACK WAVE" :              
              this.loadPackWaveStatus(widget,result,criteria);
              break;
            default :
              this.loadWaveStatusCombine(widget,result); 
              break;
          }
                
          this._commonService.lastUpdatedTime = lastUpdatedTime;
        }

        if (widget.IfNoDataFound) {
          widget.errorMessage = errorMessages.noWidgetData;
        }         

        widget.dataLoaded = true;
      },
      err => {
        console.log("listenFor broadcastWaveOrderStatus error", err);        
      }
    );
  }

  loadWaveStatusCombine(widget: any,result:any){
    widget.chartOptions = this.PieChartOptions();    
      
    let tmData: any = _.mapValues(
      _.groupBy(result, item => item.Status), x =>
        x.map(y =>
          _.omit(y, [
            "CUSTOMER_ID",
            "FACILITY",
            "PackWaveId",
            "Lastupdate",
            "Wave",
            "WaveDesc",
            "LastUpdate",
            "widgetid",
            "widgetcreationtime",
            "IsNoDataFound",
            "LastUpdateTime"              
          ])
        )
    );
    
    let units = [];
    let cartons = [];
    let colors = [];
    _.forEach(tmData, (x,item,arr) => {        
          let unitQty = 0;
          let cartonQty = 0;
          _.forEach(arr[item],(eaArr) => {
            if(eaArr.GroupBy && eaArr.GroupBy.toUpperCase() == 'UNIT'){
              unitQty = unitQty + eaArr.Quantity;
            }
            else if(eaArr.GroupBy && eaArr.GroupBy.toUpperCase() == 'CARTON'){
              cartonQty = cartonQty + eaArr.Quantity;
            }
          });        
          
          if(item && item != '' && item != 'null'){
            let color = this.colorCodes.find(x => {return x.status == item.toUpperCase()})
            if(color){
              colors.push(color.color)
            }
            cartons.push({name:item,value:cartonQty});   
            units.push({name:item,value:unitQty}); 
          }                
    }); 
    
    if(cartons.length == 0 && units.length == 0){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    } 
    
    this.addPieDataSeries(widget.chartOptions, cartons, "Cartons", 'pie')   
    if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
      widget.chartOptions.series[0].radius =   ['25%', '40%']; 
      widget.chartOptions.series[0].center =   ['30%', '50%'];   
    }

    this.addPieDataSeries(widget.chartOptions, units, 'Units', 'pie')  
    if(widget.chartOptions.series && widget.chartOptions.series.length > 1){      
      widget.chartOptions.series[1].radius =['25%', '40%'];
      widget.chartOptions.series[1].center = ['75%', '50%'];     
    }     
    widget.chartOptions.title = [{
        subtext: 'Carton',
        left: '30%',
        top: '5%',
        textAlign: 'center',
        subtextStyle:{fontSize:'14',fontWeight:'bold'}
      }, {
        subtext: 'Unit',
        left: '75%',
        top: '5%',
        textAlign: 'center',
        subtextStyle:{fontSize:'14',fontWeight:'bold'}
      }      
    ];   
    widget.chartOptions.color = colors;
    widget.chartOptions.tooltip.formatter = this.pieChartTooltipFormatter;
  }

  loadWaveStatusIndividual(widget: any,result:any){
    widget.chartOptions = this.chartOptions();    
    
    let categoryList = [];    
    let status = [];
    let category = []; 
    let colors = [];

    //Sort result with wave number
    let sortedData = this._commonService.sortArray(result, 'Wave');

    for (let i = 0; i < sortedData.length; i++) {
      if (sortedData[i].Status && sortedData[i].Status != '' && status.indexOf(sortedData[i].Status) == -1) {
        status.push(sortedData[i].Status);
      }
      if (sortedData[i].Wave && sortedData[i].Wave != '' && categoryList.indexOf(sortedData[i].Wave) == -1)  {
        categoryList.push(sortedData[i].Wave);
        category.push(sortedData[i].Wave + (sortedData[i].WaveDesc ? '\n' + sortedData[i].WaveDesc : ''));
      }
    }  

    if(status.length == 0 ||  categoryList.length == 0 ){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }
    
    status.forEach(s =>{
      let cartonQty = [];  
      let unitQty = [];  

      categoryList.forEach(c => {
        let itemFound = sortedData.filter(item => {
          return item.Wave == c && item.Status == s && item.GroupBy.toUpperCase() == "CARTON";
        });

        if(itemFound){
          if(itemFound.length > 0){
            let qty = 0;
            itemFound.forEach(q => {
              qty = qty + q.Quantity;
            });
            cartonQty.push({name:'Carton',value:qty});
          }          
        }
        else{
          cartonQty.push({name:'Carton',value:null});
        }      

        itemFound = sortedData.filter(item => {
          return item.Wave == c && item.Status == s && item.GroupBy.toUpperCase() == "UNIT";
        });

        if(itemFound){
          if(itemFound.length > 0){
            let qty = 0;
            itemFound.forEach(q => {
              qty = qty + q.Quantity;
            });
            unitQty.push({name:'Unit',value:qty});
          }          
        }
        else{
          unitQty.push({name:'Carton',value:null});
        } 
      });

      let color = this.colorCodes.find(x => {return x.status == s.toUpperCase()})
      if(color){
        colors.push(color.color)
      }

      this.addDataSeries(widget.chartOptions, cartonQty,s,'bar','a')   
      this.addDataSeries(widget.chartOptions, unitQty,s, 'bar','b')   
    });

    widget.chartOptions.color = colors;
    widget.chartOptions.xAxis.data = category;
    widget.chartOptions.grid.left = '6%';
    widget.chartOptions.grid.bottom = '6%';
    widget.chartOptions.xAxis.axisLabel.rotate = 45;
    widget.chartOptions.tooltip.formatter = this.tooltipNameValueFormater;
    if(category && category.length > 10)    {
      this.addZoomBarEnd(widget.chartOptions,0,30); 
    }
    else {
      this.addZoomBar(widget.chartOptions); 
    }
    
    if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
      widget.chartOptions.series.forEach(s => {
        s.label = { show: true, position: 'inside'};
      });
    }
    
  }

  loadPackWaveStatus(widget: any,result:any, criteria){
    if(!criteria || ! criteria.ReleasedWaveLkp){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }

    let data = result.filter(x => { return x.Wave && x.Wave == criteria.ReleasedWaveLkp.value});
    if(!data || data.length == 0){
      widget.errorMessage = errorMessages.noWidgetData;
      return;
    }
    else{
      widget.chartOptions = this.chartOptions();    

      let status = [];
      let category = []; 
      let categoryList = []; 
      let colors = [];

      for (let i = 0; i < data.length; i++) {
        if (data[i].Status && data[i].Status != '' && status.indexOf(data[i].Status) == -1) {
          status.push(data[i].Status);
        }
        if (data[i].PackWaveId && data[i].PackWaveId != '' && categoryList.indexOf(data[i].PackWaveId) == -1)  {
          categoryList.push(data[i].PackWaveId);       
          category.push(data[i].PackWaveId + (data[i].Wave ? '\n' + 'Wave: ' + data[i].Wave : ''));  
        }
      } 
      if(status.length == 0 || categoryList.length == 0){
        widget.errorMessage = errorMessages.noWidgetData;
        return;
      }
      
      status.forEach(s =>{
        let cartonQty = [];  
        let unitQty = [];  

        categoryList.forEach(c => {
          let itemFound = data.filter(item => {
            return item.PackWaveId == c && item.Status == s && item.GroupBy.toUpperCase() == "CARTON";
          });

          if(itemFound){
            if(itemFound.length > 0){
              let qty = 0;
              itemFound.forEach(q => {
                qty = qty + q.Quantity;
              });
              cartonQty.push({name:'Carton',value:qty});
            }          
          }
          else{
            cartonQty.push({name:'Carton',value:null});
          }      

          itemFound = data.filter(item => {
            return item.PackWaveId == c && item.Status == s && item.GroupBy.toUpperCase() == "UNIT";
          });

          if(itemFound){
            if(itemFound.length > 0){
              let qty = 0;
              itemFound.forEach(q => {
                qty = qty + q.Quantity;
              });
              unitQty.push({name:'Unit',value:qty});
            }          
          }
          else{
            unitQty.push({name:'Unit',value:null});
          } 
        });

        let color = this.colorCodes.find(x => {return x.status == s.toUpperCase()})
        if(color){
          colors.push(color.color)
        }
        this.addDataSeries(widget.chartOptions, cartonQty,s, 'bar','a')   
        this.addDataSeries(widget.chartOptions, unitQty,s, 'bar','b')   
      });

      widget.chartOptions.color = colors;
      widget.chartOptions.xAxis.data = category;
      widget.chartOptions.grid.left = '6%';
      widget.chartOptions.grid.bottom = '6%';
      widget.chartOptions.xAxis.axisLabel.rotate = 45;
      widget.chartOptions.tooltip.formatter = this.tooltipNameValueFormater;
      if(category && category.length > 10)    {
        this.addZoomBarEnd(widget.chartOptions,0,30); 
      }
      else {
        this.addZoomBar(widget.chartOptions); 
      }
      if(widget.chartOptions.series && widget.chartOptions.series.length > 0){
        widget.chartOptions.series.forEach(s => {
          s.label = { show: true, position: 'inside'};
        });
      }
      widget.chartOptions.title = [{
          subtext:  'Wave: ' + criteria.ReleasedWaveLkp.label,
          // left: '2%',
          top: '-2%',
          textAlign: 'left',
          subtextStyle:{fontSize:'12',fontWeight:'bold'}
      }];
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/services/widgets/wavestatusdashboard.service.ts